<template>
  <b-container fluid>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>

    <template v-else>
      <a-form layout="vertical" @submit="onSubmit">
        <div class="row">
          <div class="col-xl">
            <a-form-item label="Serial">
              <a-textarea
                placeholder="Serial"
                row="3"
                v-model="form.serialNumber"
              />
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Número Lógico">
              <a-input placeholder="Número Lógico" v-model="form.logicNumber" />
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Estabelecimento:" label-for="idMerchant">
              <v-select
                label="name"
                :filterable="false"
                :options="merchants"
                :reduce="merchant => merchant.id"
                v-model="form.idMerchant"
                @search="onSearch"
              >
                <template slot="no-options">Pesquisar Estabelecimento</template>
                <template slot="option" slot-scope="option">{{
                  option.name
                }}</template>
                <template slot="selected-option" slot-scope="option">{{
                  option.name
                }}</template>
              </v-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-xl">
            <a-form-item label="Adquirente">
              <a-select
                :default-value="form.idAcquirer"
                v-model="form.idAcquirer"
              >
                <a-select-option :value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idAcquirer"
                  v-for="(item, index) in adquirentes"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Fabricante:">
              <a-select
                :default-value="form.idDeviceBrand"
                v-model="form.idDeviceBrand"
              >
                <a-select-option :value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceBrand"
                  v-for="(item, index) in fabricantes"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Modelo:">
              <a-select
                :default-value="form.idDeviceModel"
                v-model="form.idDeviceModel"
              >
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceModel"
                  v-for="(item, index) in modelos"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Categoria:">
              <a-select default-value="null" v-model="form.idDeviceCategory">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceCategory"
                  v-for="(item, index) in categorias"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-xl" v-if="form.idDevice > 0">
            <a-form-item label="Status:">
              <a-select default-value="0" v-model="form.idDeviceStatus">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceStatus"
                  v-for="(item, index) in statusDispositivos"
                  :key="`statusDispositivo-${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Nota Fiscal:">
              <a-input
                placeholder="# da nota fiscal"
                v-model="form.invoiceNumber"
              />
            </a-form-item>
          </div>

          <div class="col-xl" v-if="showCostCenter">
            <a-form-item label="Centro de Custo:">
              <a-select default-value="null" v-model="form.idCostCenter">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idCostCenter"
                  v-for="(item, index) in costCenters"
                  :key="`costcenter-${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="d-flex justify-content-end col-12">
            <b-button
              class="col-md-2 ml-3 mt-2"
              variant="outline-primary"
              @click="cancelar()"
            >
              Voltar
            </b-button>
            <b-btn
              type="submit"
              class="col-md-2 ml-3 mt-2"
              variant="outline-primary"
              :disabled="loading"
            >
              Salvar
              <b-spinner
                small
                variant="primary"
                label="Spinning"
                v-show="loading"
              ></b-spinner>
            </b-btn>
          </div>
        </div>
      </a-form>
    </template>
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import { EquipamentosResource } from "@/resources/Equipamentos.resource.js";
export default {
  name: "FormularioEquipamentos",
  data() {
    return {
      loading: false,
      statusDispositivos: [],
      adquirentes: [],
      fabricantes: [],
      costCenters: [],
      merchants: [
        this.device
          ? {
              id: _get(this.device, "idMerchant", ""),
              name: _get(this.device, "merchantName", "Pesquisar Estabelecimento")
            }
          : null
      ],

      modelos: [],
      categorias: [],
      form: {
        idDevice: _get(this.device, "idDevice", 0),
        serialNumber: _get(this.device, "serialNumber", ""),
        logicNumber: _get(this.device, "logicNumber", ""),
        idDeviceModel: _get(this.device, "idDeviceModel", null),
        idDeviceStatus: _get(this.device, "idDeviceStatus", null),
        idAcquirer: _get(this.device, "idAcquirer", null),
        idMerchant: _get(this.device, "idMerchant", null),
        idDeviceBrand: _get(this.device, "idDeviceBrand", null),
        idDeviceCategory: _get(this.device, "idDeviceCategory", null),
        idCostCenter: _get(this.device, "idCostCenter", null)
      }
    };
  },
  props: {
    device: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
   computed: {
   
    showCostCenter()
    {
        try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0)

        return result;
      } catch (e) {
        return false;
      }
    }
  },

  watch: {
    "form.idDeviceBrand": function(v) {
      this.getDeviceModel(v);
    }
  },

  methods: {
    cancel() {
      this.$emit("hide");
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search
          }
        })
        .then(result => {
          loading(false);
          vm.merchants = result.data.payload.map(item => ({
            id: item.id,
            name: item.description
          }));
        })
        .catch(e => {
          // Surpress
        });
    }, 350),
    getDeviceStatus() {
      this.$api
        .get("v1/DeviceStatus")
        .then(result => {
          this.statusDispositivos = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    },
    getDeviceBrand() {
      this.$api
        .get("v1/DeviceBrand")
        .then(result => {
          this.fabricantes = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    },
    getDeviceModel(brand) {
      this.$api
        .get(`v1/DeviceModel/listByBrand/${brand}`)
        .then(result => {
          this.modelos = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    },
    getDeviceCategories(brand) {
      this.$api
        .get("v1/DeviceCategory")
        .then(result => {
          this.categorias = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    },
    getAcquirer() {
      this.$api
        .get("v1/Acquirer")
        .then(result => {
          this.adquirentes = result.data.payload.items;
        })
        .catch(e => {
          // Surpress
        });
    },

    getCostCenter() {
      this.$api
        .get("v1/CostCenter")
        .then(result => {
          this.costCenters = result.data.payload.items;
        })
        .catch(e => {
          // Surpress
        });
    },

    cancelar() {
      this.$router.push({
        name: "device"
      });
    },

    async onSubmit(e) {
      const POS_PENDING_STATUS = 1;
      e.preventDefault();

      const data = {
        device: {
          ...this.form
        }
      };

      if(!this.showCostCenter){
         data.idCostCenter = parseInt(this.$store.getters.user.costcenter);
      }

      this.loading = true;
      const vm = this;
      if (data.device.idDevice == 0) {
        data.device.idDeviceStatus = POS_PENDING_STATUS;

        EquipamentosResource.register(data)
          .then(result => {
            try {
              this.loading = false;
              this.$notification["success"]({
                message: "Registro inserido",
                description: ""
              });

              this.$router.push({
                name: "device"
              });
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            this.loading = false;
            this.$notification["error"]({
              message: e.response.data.failureReason,
              description: ""
            });
          });
      } else {
        EquipamentosResource.update(data)
          .then(result => {
            try {
              // this.idMerchant = result.data.payload;
              this.loading = false;
              this.$notification["success"]({
                message: "Registro atualizado",
                description: ""
              });

              this.$router.push({
                name: "device"
              });
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            this.loading = false;
          });
      }
    },

    editar() {
      // TODO - remover e verificar se teremos metodos diferentes para isso....
      this.adicionar();
    },
    adicionar() {
      this.loading = true;
      this.$api
        .put("v1/Device", {
          device: this.form
        })
        .then(result => {
          // Surpress
        })
        .catch(e => {
          // Surpress
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {},
  created() {
    // primeiro momento da pagina, carrega os dados dos filtros...
    // verificar o quanto estes dados mudam para fazer um cache no vuex....
    this.getDeviceStatus();
    this.getAcquirer();
    this.getDeviceBrand();
    this.getDeviceCategories();
    this.getCostCenter();
    if (this.device.idDeviceBrand != "undefined") {
      this.getDeviceModel(this.device.idDeviceBrand);
    }
  }
};
</script>
